export const menuItems = [
  {
    location: '/user/reservations',
    name: 'Reservations',
  },
]

export const classes = {
  navBar: 'bg-light',
}
